<template>
    <div class="flex ai:center gap:8 username">
        <member-avatar :icon-url="avatar" :short-name="short" :type="type"></member-avatar>
        <div class="ai:center gap:8 flex:1 d:none">
            <span>{{ nickname }}</span>
            <button class="w:20 h:20 bg:url(image/btn_change_username.svg) b:0 inline-block" @click="emit('chuser', type)" type="button"></button>
        </div>
    </div>
    <div class="word-break:break-all">
        <topic-content comment editable @focus="emit('focus')" placeholder="你在想什麼？" ref="replyInput" @submit="update" :to="to?.floor" v-model="items"></topic-content>
    </div>
    <div class="buttons mt:4 jc:space-between ai:center d:none">
        <div class="inline-flex gap:16 ai:center">
            <button class="bg:url(image/icon_image_upload.svg) w:19 h:18 b:0" @click="openImagePicker" type="button"></button>
            <input accept="image/*" @change="pickImage" class="hidden" multiple ref="imageInput" type="file" />
        </div>
        <div class="flex ai:center gap:12">
            <button class="p:0 b:0 color:#A9A9A9" @click="cancel" type="button" v-if="data">取消</button>
            <button class="p:0 b:0 bg:url(image/btn_comment_submit.svg) w:18 h:18 inline-block" @click="update" type="button" v-if="!empty"></button>
        </div>
    </div>
</template>

<script setup>
    const userInfo = useUserInfo();

    const imageInput = ref();
    const replyInput = ref();

    const props = defineProps({
        fixed: { default: false, type: Boolean },
        data: { type: Object },
        to: { type: Object }
    });

    const data = ref();

    const items = ref([]);

    const avatar = computed(() => data.value ? data.value.avatar_url : userInfo.avatar_url);
    const empty = computed(() => !items.value.filter((item) => item.type !== 1 || item.text.trim()).length);
    const nickname = computed(() => data.value ? data.value.nickname : userInfo.display_name);
    const short = computed(() => data.value ? data.value.short_name : userInfo.short_name);
    const type = computed(() => data.value ? data.value.nickname_type : userInfo.type);

    const cancel = () => {
        emit("cancel");
        init();
    };

    const emit = defineEmits(["cancel", "chuser", "focus", "update"]);

    const focus = () => {
        replyInput.value.focus();
    };

    const init = () => {
        if (props.data) {
            data.value = JSON.parse(JSON.stringify(props.data));
            items.value = data.value.content;
        } else {
            items.value = [];
        }

        items.value.push({ text: "", type: 1 });
    };

    const openImagePicker = () => {
        imageInput.value.click();
    };

    const pickImage = () => {
        replyInput.value.addImages(imageInput.value.files);
        imageInput.value.value = "";
    };

    const update = () => {
        if (!empty.value) {
            emit("update", {
                nickname_type: type.value,
                content: items.value.filter((item) => item.type !== 1 || item.text.trim())
            });
        }
    };

    defineExpose({ focus, init });

    init();

    if (props.data) {
        watch(() => props.data.newType, (newType) => {
            if (newType) {
                data.value.nickname_type = newType;
                data.value.nickname = userInfo.getDisplayName(newType);
                props.data.newType = null;
            }
        });
    }
</script>
